module.exports = __webpack_public_path__ + "static/img/bl_2.7d4e915.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/mainBusiness/bl_2.png
// module id = jZ7T
// module chunks = 0